<template>
  <v-form v-model="valid" ref="form">
    <v-row class="mt-4">
      <v-col cols="6" sm="3" md="3">
        <decimal-number-input dense label="Default price" :precision="4" :suffix="product.bottlesPerUnit===1 ? '/bottle' : '/unit'" v-model="product.defaultPrice"/>
      </v-col>
      <v-col cols="6" sm="3" md="3">
        <v-autocomplete outlined dense label="Default tax" v-model="product.defaultTaxId" :items="taxes" item-value="id" item-text="name"/>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" lg="9">
        <customer-pricing :customers="product.customers" :taxes="taxes"
                          :default-sku="product.sku" :defaultPrice="product.defaultPrice" :defaultTaxId="product.defaultTaxId" units="Bottle"/>
      </v-col>
    </v-row>
   </v-form>
</template>

<script>
import CustomerPricing from '@/components/CustomerPricing'

export default {
  name: 'InventoryProductsEditDutyPaidNoProvince',
  components: {CustomerPricing},
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true},
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  watch: {
    valid () {
      this.$emit('input', this.valid);
    }
  }
}
</script>